<template>
  <header class="site-header">
    <div class="wrap">
      <a href="#" class="brand" @click.prevent>
        <img src="/assets/logos/HYBRID-ISLAND-RACE-H-NARANJA.svg" alt="Hybrid Island Race" />
      </a>
      <nav class="desktop-nav">
        <a href="#format">La carrera</a>
        <a href="#pruebas">Pruebas</a>
        <a href="#schedule">Programa</a>
        <a :href="REGISTRATION_URL" target="_blank" rel="noopener">Inscripción</a>
        <a href="#contact">Contacto</a>
      </nav>
      <div class="header-meta">
        <MapPin :size="14" class="pin-icon" />
        Ciutadella · 03 OCT 2026
      </div>
      <a class="btn btn-primary" :href="REGISTRATION_URL" target="_blank" rel="noopener">Inscríbete →</a>
      <button
        class="menu-toggle"
        aria-label="Abrir menú"
        :aria-expanded="menuOpen"
        @click="menuOpen = true"
      >
        <Menu :size="26" />
      </button>
    </div>

    <Teleport to="body">
      <div
        class="menu-overlay"
        :class="{ open: menuOpen }"
        @click="menuOpen = false"
      ></div>

      <aside class="mobile-menu" :class="{ open: menuOpen }">
        <div class="mobile-menu-head">
          <span class="mobile-menu-title">Menú</span>
          <button class="menu-close" aria-label="Cerrar menú" @click="menuOpen = false">
            <X :size="26" />
          </button>
        </div>
        <nav class="mobile-nav">
          <a href="#format" @click="menuOpen = false">La carrera</a>
          <a href="#pruebas" @click="menuOpen = false">Pruebas</a>
          <a href="#schedule" @click="menuOpen = false">Programa</a>
          <a :href="REGISTRATION_URL" target="_blank" rel="noopener" @click="menuOpen = false">Inscripción</a>
          <a href="#contact" @click="menuOpen = false">Contacto</a>
        </nav>
        <div class="mobile-menu-meta">
          <MapPin :size="14" class="pin-icon" />
          Ciutadella · 03 OCT 2026
        </div>
      </aside>
    </Teleport>
  </header>
</template>

<script setup>
import { ref, watch } from 'vue'
import { MapPin, Menu, X } from 'lucide-vue-next'
import { REGISTRATION_URL } from '@/registration'

const menuOpen = ref(false)

watch(menuOpen, (open) => {
  document.body.style.overflow = open ? 'hidden' : ''
})
</script>
